(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('exchangerate', {
            parent: 'entity',
            url: '/exchangerate?page&sort&search',
            data: {
                authorities: ['ROLE_MANAGER'],
                pageTitle: 'exchangerate.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/exchangerate/exchangerates.html',
                    controller: 'ExchangerateController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('exchangerate');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('exchangerate-detail', {
            parent: 'entity',
            url: '/exchangerate/{id}',
            data: {
                authorities: ['ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.exchangerate.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/exchangerate/exchangerate-detail.html',
                    controller: 'ExchangerateDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('exchangerate');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Exchangerate', function($stateParams, Exchangerate) {
                    return Exchangerate.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'exchangerate',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('exchangerate-detail.edit', {
            parent: 'exchangerate-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exchangerate/exchangerate-dialog.html',
                    controller: 'ExchangerateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Exchangerate', function(Exchangerate) {
                            return Exchangerate.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('exchangerate.new', {
            parent: 'exchangerate',
            url: '/new',
            data: {
                authorities: ['ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exchangerate/exchangerate-dialog.html',
                    controller: 'ExchangerateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                usdToKrw: null,
                                usdToUzs: null,
                                krwToUzs: null,
                                mileagePercentageRate: null,
                                euroDivisor: null,
                                yahooEurToUsd: null,
                                yahooUsdToKrw: null,
                                yahooUsdToUzs: null,
                                mangoPaynetRate: null,
                                mangoSpecialPrice: null,
                                pubDate: null,
                                lastEdited: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('exchangerate', null, { reload: 'exchangerate' });
                }, function() {
                    $state.go('exchangerate');
                });
            }]
        })
        .state('exchangerate.edit', {
            parent: 'exchangerate',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exchangerate/exchangerate-dialog.html',
                    controller: 'ExchangerateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Exchangerate', function(Exchangerate) {
                            return Exchangerate.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('exchangerate', null, { reload: 'exchangerate' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('exchangerate.delete', {
            parent: 'exchangerate',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/exchangerate/exchangerate-delete-dialog.html',
                    controller: 'ExchangerateDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Exchangerate', function(Exchangerate) {
                            return Exchangerate.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('exchangerate', null, { reload: 'exchangerate' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
